import VideoCaptionsStylizedIcon from '@atlaskit/icon-lab/core/video-captions-stylized';
import * as React from 'react';

export function SvgCaptions() {
  return <VideoCaptionsStylizedIcon label="" testId="ads-refreshed-icon" />;
}
